<template>
  <button
    :class="classObject"
    :disabled="loading || disabled"
    class="default-button focus:outline-none focus:shadow-outline whitespace-no-wrap">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: "Submit"
    },

    primary: {
      type: Boolean,
      default: false
    },

    secondary: {
      type: Boolean,
      default: false
    },

    tertiary: {
      type: Boolean,
      default: false
    },

    small: {
      type: Boolean,
      default: false
    },

    large: {
      type: Boolean,
      default: false
    },

    skinny: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    classObject () {
      return {
        "loading": this.loading,
        "disabled": this.disabled,
        "text-gray-900 bg-white": !this.primary && !this.tertiary && !this.secondary,
        "text-black bg-white hover:bg-gray-200 border border-transparent select-none": this.primary,
        "text-gray-800 bg-transparent hover:bg-gray-200 border border-gray-300": this.secondary,
        "text-black bg-pink-600 hover:bg-green-700 border border-transparent text-white": this.tertiary,
        "px-4 py-2 text-xs": this.small,
        "w-full px-4 sm:px-24 py-4 text-xl": this.large,
        "px-12 py-3": !this.small && !this.large && !this.skinny,
      }
    }
  }
}
</script>
